import React from 'react';
import { motion } from 'framer-motion';
type BonusCardProps = {
  number: number;
  title: string;
  description: string;
};

/** Card for a single free bonus (🎁 BONO N) with a "HOY GRATIS" tag. */
export function BonusCard({
  number,
  title,
  description
}: BonusCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.3
  }} transition={{
    duration: 0.4,
    delay: number % 3 * 0.08
  }} className="relative flex h-full flex-col rounded-2xl border border-cream-deep bg-white p-6 shadow-sm" data-id="element-116" data-mp="2x4gmhv8vv1io">
      <span className="absolute right-4 top-4 rounded-full bg-sage px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-wide text-white" data-id="element-117" data-mp="29ew1z7x2zw7a">
        Hoy gratis
      </span>
      <div className="text-3xl" aria-hidden="true" data-id="element-118" data-mp="1ho83y4qpf6xu">🎁</div>
      <p className="mt-3 text-xs font-extrabold uppercase tracking-widest text-sage-deep" data-id="element-119" data-mp="1hnpyqim2dids">
        Bono {number}
      </p>
      <h3 className="mt-1 font-serif text-lg font-bold text-ink" data-id="element-120" data-mp="1ln77pm0p8xnp">{title}</h3>
      <p className="mt-2 text-sm leading-relaxed text-ink/70" data-id="element-121" data-mp="1x1bnj97domgv">{description}</p>
    </motion.div>;
}